import script from "./RidEntity.vue?vue&type=script&setup=true&lang=js"
export * from "./RidEntity.vue?vue&type=script&setup=true&lang=js"

import "./RidEntity.vue?vue&type=style&index=0&id=4abadde3&scoped=true&lang=scss"

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4abadde3"]])

export default __exports__